/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
export default function Fct03NTNN() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const { formId, formField } = form;

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} />
          <Actions />
        </>
      )}
            <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
        {tab === 0 && (
                <Box display="flex" flexDirection="column" pb={10} gap={3}>
                <Box textAlign="center">
                  <Typography variant="h4" textTransform="uppercase">
                    Tờ khai  thuế nhà thầu nước ngoài - Mẫu 03/NTNN
                  </Typography>
                  <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                  (Áp dụng đối với nhà thầu nước ngoài trực tiếp nộp thuế TNDN theo tỷ lệ % trên doanh thu tính thuế)
                  </Typography>
                  
                </Box>
                <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleSubmit}>
                  {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                    <Form id={formId} autoComplete="off">
                      <Fields
                        formData={{
                          values,
                          touched,
                          formField,
                          errors,
                        }}
                      />
                      <TaxPersonalTable
                        formData={{
                          values,
                          touched,
                          formField,
                          errors,
                        }}
                        setFieldValue={setFieldValue}
                      />
                      <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                        <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                          {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                        </SoftButton>
                      </SoftBox>
                    </Form>
                  )}
                </Formik>
              </Box>
        )}
        </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxAlternatePayerId,
    taxName,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxName.name}
            label={taxName.label}
            value={values.taxName}
            error={errors.taxName && touched.taxName}
            success={values.taxName?.toString().length > 0 && !errors.taxName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAlternatePayerId.name}
            label={taxAlternatePayerId.label}
            value={values.taxAlternatePayerId}
            error={errors.taxAlternatePayerId && touched.taxAlternatePayerId}
            success={values.taxAlternatePayerId?.toString().length > 0 && !errors.taxAlternatePayerId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
